/* eslint-disable */
import React, { useRef, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import AppContext from "../../../../context/store";

import { Grid, Column } from "../../../../theme/Grid";
import Button from "../../../../theme/Button";
import Input from "../../../../theme/CustomMUI/Input";
import Select from "../../../../theme/CustomMUI/Select";
import AlertDialog from "../../../../theme/CustomMUI/AlertDialog";
import DatePickerInput from "../../../../theme/CustomMUI/DatePickerInput";
import MaskedInput from "../../../../theme/CustomMUI/MaskedInput";
import Axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import {
  AddBox,
  ShoppingBasket,
  AllInbox,
  Search,
  AddOutlined,
  Warning
} from "@material-ui/icons";
import { InputAdornment } from "@material-ui/core";
import Loader from "../../../../assets/images/loader.gif";
import LoaderEN from "../../../../assets/images/circular.gif";
import LoaderSM from "../../../../assets/images/loaderSM.gif";
import { flushSync } from "react-dom";
import RemainingDebtRed from "../../../../assets/images/svg/remaining_debt_red.svg";
import StaffSelect from "../../../../theme/CustomMUI/StaffSelect";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import PackageTable from "../../../../theme/PackageTable";
import Waiting from "../../../../assets/images/svg/waiting-receipt.svg";
import HomeChcek from "../../../../assets/images/svg/home-check-receipt.svg";
import NotCome from "../../../../assets/images/svg/notCome-receipt.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import AppointmentCardDetail from "../../../../components/Dialogs/AppointmentCardDetail";
import Cash from "../../../../assets/images/svg/cash.svg";
import Credit from "../../../../assets/images/svg/credit.svg";
import Transfer from "../../../../assets/images/svg/transfer.svg";
import CustomerPoint from "../../../../assets/images/svg/customer_point.svg";
import CashWhite from "../../../../assets/images/svg/cash_white.svg";
import CreditWhite from "../../../../assets/images/svg/credit_white.svg";
import CustomerPointWhite from "../../../../assets/images/svg/customer_point_white.svg";
import TransferWhite from "../../../../assets/images/svg/transfer_white.svg";
import RemainingDebt from "../../../../assets/images/svg/remaining_debt.svg";

const themeForDatePicker = createTheme({
  typography: {
    fontSize: 11,
  },
});

// Paket özetinin gösterildiği alan.

export const _PackageSummaryBuilder = ({
  is_package,
  packageSummaryGenerator
}) => {
  const context = useContext(AppContext);

  return (
    is_package && (
      <SectionBox style={{ overflow: "hidden" }}>
        <SectionHeading
          style={{
            backgroundColor: "rgba(140,15,180, 0.1)",
            color: "#8c0fb4",
            border: "1px solid #8c0fb4",
            padding: "10px",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            height: "40px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <AllInbox />
            <h3 style={{ marginLeft: "15px" }}>
              {context.t(`['receipt/detail/id'].packageInner.title`)}
            </h3>
          </div>
        </SectionHeading>
        <div
          style={{
            marginBottom: "auto",
            overflow: "scroll",
          }}
          className="no-scroll-bar"
        >
          <PackageTable
            headings={{
              "service.name": {
                label: context.t(
                  `['receipt/detail/id'].packageInner.headings.name`
                ),
              },
              total: {
                label: context.t(
                  `['receipt/detail/id'].packageInner.headings.count`
                ),
                rowStyleType: "primary",
              },
              completed: {
                label: context.t(
                  `['receipt/detail/id'].packageInner.headings.completed`
                ),
                rowStyleType: "success",
              },
              pending: {
                label: context.t(
                  `['receipt/detail/id'].packageInner.headings.pending`
                ),
                rowStyleType: "warn",
              },
            }}
            rows={packageSummaryGenerator()}
          />
        </div>
      </SectionBox>
    )
  );
};

// Paket satışı eklemek için açılan dialog.

export const _PackageSalesDialogBuilder = ({
  packages,
  setPackages,
  lateCheckout,
  setLateCheckout,
  package_sale_modal,
  setPackageSaleModal,
  new_package,
  setNewPackage,
  total_loader,
  setTotalLoader,
  total,
  setTotal,
  selected_customer,
  __package,
  set__Package,
  staffs,
  rooms,
  services,
  save_button_disabled,
  setSaveButtonDisabled,
  paramsId,
  getSingleReceipt
}) => {
  const context = useContext(AppContext);
  let typingTimeout = null;

  const _total = () => {
    return {
      amount: Object.keys(new_package.services)
        .filter((key) => new_package.services[key] !== undefined)
        .map((key) =>
          new_package.services[key].amount !== null
            ? Math.round(new_package.services[key].amount) *
            new_package.services[key].period
            : 0
        )
        .reduce((a, b) => a + b, 0),

      getRatioList: () => {
        const SingleRatio = {};
        const totalAmount = _total().amount;

        if (totalAmount === 0) return SingleRatio;

        Object.keys(new_package.services)
          .filter((key) => new_package.services[key] !== undefined)
          .forEach((key) => {
            SingleRatio[key] =
              new_package.services[key].amount !== null
                ? (Math.round(new_package.services[key].amount) *
                  new_package.services[key].period) /
                totalAmount
                : 0;
          });
        return SingleRatio;
      },
    };
  };

  const fieldChanger = (section, key, payload) => {
    // Eğer amount güncelleniyorsa tam sayıya çevir
    if (payload.amount !== undefined) {
      payload.amount = payload.amount !== null ? Math.round(payload.amount) : null;
    }

    const updatedPackage = {
      ...new_package,
      [section]: {
        ...new_package[section],
        [key]: {
          ...new_package[section][key],
          ...payload,
        },
      },
    };

    setNewPackage(updatedPackage);
    setTotal(_total().amount);
  };

  const editTotal = () => {
    if (total !== 0 || total !== null) {
      const newTotal = parseInt(total);
      const services = { ...new_package.services };
      const serviceKeys = Object.keys(services).filter(key => services[key] !== undefined);

      if (serviceKeys.length === 0) return;

      // Toplam 0'ı aşmalı
      if (newTotal <= 0) return;

      // İlk olarak tüm seansların fiyatlarını hesapla (son bir tanesi hariç)
      let totalCalculated = 0;

      serviceKeys.slice(0, -1).forEach(key => {
        const service = services[key];
        if (!service) return;

        const ratio = _total().getRatioList()[key] || (1 / serviceKeys.length);
        const periodAmount = Math.round((newTotal * ratio) / service.period);

        services[key] = {
          ...service,
          amount: periodAmount
        };

        totalCalculated += periodAmount * service.period;
      });

      // Son seansa kalan tutarı ata (toplam tutar ile hesaplanan toplam arasındaki farkı ayarla)
      const lastKey = serviceKeys[serviceKeys.length - 1];
      const lastService = services[lastKey];

      if (lastService) {
        const remainingAmount = newTotal - totalCalculated;
        const lastPeriodAmount = Math.round(remainingAmount / lastService.period);

        services[lastKey] = {
          ...lastService,
          amount: lastPeriodAmount > 0 ? lastPeriodAmount : 1 // En az 1 olmalı
        };
      }

      setTotalLoader(false);
      setNewPackage({
        ...new_package,
        services,
      });
    }
  };

  const validatePackage = () => {
    let undefinedServiceCount = 0;
    let staffOrRoomMissingCount = 0;

    Object.keys(new_package.services).forEach((key) => {
      const service = new_package.services[key];
      if (service.service_id === undefined || service.service_id === null) {
        undefinedServiceCount++;
      }
      if ((!service.staff_id || service.staff_id === null) &&
        (!service.room_id || service.room_id === null)) {
        staffOrRoomMissingCount++;
      }
    });

    if (undefinedServiceCount > 0) {
      setSaveButtonDisabled(false);
      toast.warning(
        context.t(`['receipt/detail/id'].packageSale.servicePickToast`)
      );
      return false;
    }

    if (staffOrRoomMissingCount > 0) {
      setSaveButtonDisabled(false);
      toast.warning("Lütfen her hizmet için personel veya oda seçiniz!");
      return false;
    }

    if (selected_customer === null) {
      setSaveButtonDisabled(false);
      toast.warning(
        context.t(`['receipt/detail/id'].packageSale.customerPickToast`)
      );
      return false;
    }

    return true;
  };

  return (
    <AlertDialog
      fullWidth
      maxWidth={__package ? "lg" : "sm"}
      title={context.t(`['receipt/detail/id'].packageSale.title`)}
      open={package_sale_modal}
      disableBackdropClick={false}
      closeHandler={() => setPackageSaleModal(false)}
    >
      <Select
        label={context.t(
          `['receipt/detail/id'].packageSale.packageNameInputLabel`
        )}
        items={[...packages]}
        selected={__package ? __package.id : null}
        labelKey="name"
        valueKey="id"
        returnFullObject
        handler={(_package) => {
          flushSync(() => {
            set__Package(_package);
            const newServices = _package.packet_details
              ? Object.assign(
                ..._package.packet_details.map((item, index) => ({
                  [(index + 1) * (Object.keys(new_package.services).length + 1)]: {
                    service_id: item?.service_id,
                    staff_id: null,
                    room_id: null,
                    packet_id: item.packet_id,
                    amount: item.amount || 0,
                    period: item.period,
                    period_between: 7,
                    period_start: moment().format("YYYY-MM-DD"),
                    process_type: 1,
                    name: _package.name,
                  },
                }))
              )
              : {};

            setNewPackage({
              services: newServices
            });

            // Yeni paket seçildiğinde toplam tutarı sıfırla ve yeni hesapla
            setTimeout(() => {
              const newTotal = Object.values(newServices)
                .reduce((sum, service) =>
                  sum + (service.amount || 0) * (service.period || 1), 0);
              setTotal(newTotal);
            }, 0);
          });
        }}
      />
      {Object.keys(new_package.services).filter(
        (key) => new_package.services[key] !== undefined
      ).length > 0 ? (
        Object.keys(new_package.services)
          .filter((key) => new_package.services[key] !== undefined)
          .map((item, index) => (
            <Grid key={index} className="no-gutters-row">
              <Column className="xs-12 sm-12 md-12 lg-12 xl-2">
                <Select
                  label={context.t(
                    `['receipt/detail/id'].packageSale.serviceInputLabel`
                  )}
                  items={
                    new_package.services[item].staff_id
                      ? staffs
                        .filter(
                          (staff) =>
                            staff.id === new_package.services[item].staff_id
                        )[0]
                        ?.services.map((service) => service.service) || services
                      : services
                  }
                  labelKey="name"
                  valueKey="id"
                  deletedService={
                    new_package.services[item].staff_id
                      ? staffs
                        .filter(
                          (staff) =>
                            staff.id === new_package.services[item].staff_id
                        )[0]
                        ?.services.map((service) => service.service).find((el) => el.id === new_package?.services[item]?.service_id) ? [] : services?.filter((el) => el.id === new_package.services[item].service_id)?.map((data) => {
                          return ({
                            ...data,
                            is_passive: true
                          })
                        })
                      : services?.filter((el) => el.id === new_package.services[item].service_id)?.map((data) => {
                        return ({
                          ...data,
                          is_passive: true
                        })
                      })
                  }
                  serviceDisabled={true}
                  selected={
                    new_package.services[item].service_id
                      ? services.filter(
                        (ser) =>
                          ser.id === new_package.services[item].service_id
                      ).length
                        ? new_package.services[item].service_id
                        : "Silinmiş Hizmet"
                      : "Silinmiş Hizmet"
                  }
                  returnFullObject
                  handler={(service) => {
                    fieldChanger("services", item, {
                      service_id: parseInt(service.id),
                      amount: service.amount,
                    })
                  }}
                />
              </Column>
              <Column className="xs-12 sm-12 md-12 lg-12 xl-auto">
                <StaffSelect
                  optional
                  label={context.t(
                    `['receipt/detail/id'].packageSale.staffInputLabel`
                  )}
                  items={[...staffs]}
                  labelKey="full_name"
                  valueKey="id"
                  selected={new_package.services[item].staff_id ?? ""}
                  handler={(staff_id) => {
                    fieldChanger("services", item, {
                      staff_id: staff_id !== "" ? parseInt(staff_id) : null,
                    })
                  }}
                />
              </Column>
              <Column className="xs-12 sm-12 md-12 lg-12 xl-auto">
                <Select
                  label="Oda"
                  items={[
                    {
                      id: null,
                      name: "Oda Seçiniz",
                    },
                    ...(rooms || [])
                      .filter(room => room && (room.ID || room.id))
                      .map(room => ({
                        id: room.ID || room.id,
                        name: room.Name || room.name,
                      }))
                  ]}
                  selected={new_package.services[item].room_id || ""}
                  labelKey="name"
                  valueKey="id"
                  handler={(room_id) => {
                    fieldChanger("services", item, {
                      room_id: room_id !== null ? parseInt(room_id) : null,
                    })
                  }}
                />
              </Column>
              <Column className="xs-12 sm-12 md-12 lg-12 xl-auto">
                <DatePickerInput
                  label={context.t(
                    `['receipt/detail/id'].packageSale.startInputLabel`
                  )}
                  error={false}
                  value={
                    new Date(moment(new_package.services[item].period_start))
                  }
                  onChange={(period_start) =>
                    fieldChanger("services", item, {
                      period_start: moment(period_start).format("YYYY-MM-DD"),
                    })
                  }
                />
              </Column>
              <Column className="xs-12 sm-12 md-12 lg-12 xl-auto">
                <Select
                  label={context.t(
                    `['receipt/detail/id'].packageSale.periodInputLabel`
                  )}
                  items={[...new Array(50).keys()].map((i) => ({
                    value: i + 1,
                  }))}
                  labelKey="value"
                  valueKey="value"
                  selected={new_package.services[item].period ?? null}
                  handler={(period) =>
                    fieldChanger("services", item, {
                      period: parseInt(period),
                    })
                  }
                />
              </Column>
              <Column className="xs-12 sm-12 md-12 lg-12 xl-auto">
                <Select
                  label={context.t(
                    `['receipt/detail/id'].packageSale.periodBetweenInputLabel`
                  )}
                  items={[...new Array(30).keys()].map((i) => ({
                    value: i + 1,
                    label: `${i + 1} Gün`,
                  }))}
                  labelKey="label"
                  valueKey="value"
                  selected={new_package.services[item].period_between ?? null}
                  handler={(period_between) =>
                    fieldChanger("services", item, {
                      period_between: parseInt(period_between),
                    })
                  }
                />
              </Column>
              <Column className="xs-12 sm-12 md-12 lg-12 xl-auto">
                <MaskedInput
                  label={
                    context.t(
                      `['receipt/detail/id'].packageSale.periodAmountInputLabel`
                    ) +
                    (context.state.currency
                      ? " (" + context.state.currency + ")"
                      : "(₺)")
                  }
                  // mask="99,99"
                  maskChar=""
                  value={
                    new_package.services[item].amount
                      ? `${new_package.services[item].amount}`
                      : ""
                  }
                  onChange={(e) =>
                    fieldChanger("services", item, {
                      amount:
                        e.target.value && /[0-9,.]+/.test(e.target.value)
                          ? Math.round(parseFloat(e.target.value))
                          : null,
                    })
                  }
                />
              </Column>
              <Column>
                <Button
                  icon="delete_forever"
                  iconSize={20}
                  backgroundColor="red-opacity"
                  textColor="red"
                  size="lg"
                  fullWidth
                  onClick={() => {
                    delete new_package.services[item];
                    setNewPackage({
                      ...new_package,
                      services: {
                        ...new_package.services,
                      },
                    });
                    setTotal(_total().amount);
                  }}
                />
              </Column>
            </Grid>
          ))
      ) : (
        <NoDataContainer style={{ height: "70%" }}>
          <img
            src={require("../../../../assets/images/manypixels/click_action.svg")}
            alt="Malesef bulunamadı!"
          />
          <p>
            {context.t(`['receipt/detail/id'].packageSale.noDataText`)}
          </p>
        </NoDataContainer>
      )}
      {Object.keys(new_package.services).filter(
        (key) => new_package.services[key] !== undefined
      ).length > 0 && (
          <Grid className="no-gutters-row">
            <Column className="xs-12 sm-12 md-12 lg-12 xl-auto"></Column>
            <Column className="xs-12 sm-12 md-12 lg-12 xl-auto"></Column>
            <Column className="xs-12 sm-12 md-12 lg-12 xl-auto"></Column>
            <Column className="xs-12 sm-12 md-12 lg-12 xl-auto"></Column>
            <Column className="xs-12 sm-12 md-12 lg-12 xl-auto"></Column>
            <Column className="xs-12 sm-12 md-12 lg-12 xl-auto">
              <Input
                label={
                  context.t(
                    `['receipt/detail/id'].packageSale.totalAmount`
                  ) +
                  (context.state.currency
                    ? " (" + context.state.currency + ")"
                    : "(₺)")
                }
                // type="number"
                value={Math.round(total)}
                onChange={(e) => {
                  const newTotal = e.target.value && e.target.value !== "0" ? Math.round(parseFloat(e.target.value)) : 1;
                  setTotal(newTotal);
                  setTotalLoader(true);
                }}
                InputProps={{
                  endAdornment: total_loader && (
                    <InputAdornment position="end" style={{ marginRight: 0 }}>
                      <img
                        src={
                          process.env.APP_NAME === "salon"
                            ? Loader
                            : process.env.APP_NAME === "en"
                              ? LoaderEN
                              : LoaderSM
                        }
                        width="100"
                        height="100"
                        alt="loading"
                      />
                    </InputAdornment>
                  ),
                  onKeyUp: (e) => {
                    const value = e.target.value;
                    clearTimeout(typingTimeout);
                    typingTimeout =
                      value.length > 0 && setTimeout(() => editTotal(), 1250);
                  },
                }}
              />
            </Column>

            <Column>
              <div style={{ opacity: 0 }}>
                <Button
                  icon="delete_forever"
                  iconSize={20}
                  backgroundColor="red-opacity"
                  textColor="red"
                  size="lg"
                  fullWidth
                />
              </div>
            </Column>
          </Grid>
        )}
      {Object.keys(new_package.services).filter(
        (key) => new_package.services[key] !== undefined
      ).length > 0 && (
          <Button
            className="mt-2 mb-1"
            icon="local_mall"
            title={context.t(
              `['receipt/detail/id'].packageSale.completeButtonTitle`
            )}
            backgroundColor="teal-opacity"
            textColor="teal"
            disabled={save_button_disabled || (() => {
              const services = Object.keys(new_package.services).filter(
                key => new_package.services[key] !== undefined
              );

              return services.some(key => {
                const service = new_package.services[key];
                return (!service.staff_id || service.staff_id === null) &&
                  (!service.room_id || service.room_id === null);
              });
            })()}
            size="md"
            fullWidth
            onClick={() => {
              const services = Object.keys(new_package.services).filter(
                key => new_package.services[key] !== undefined
              );

              let hasInvalidService = false;
              services.forEach(key => {
                const service = new_package.services[key];
                if ((!service.staff_id || service.staff_id === null) &&
                  (!service.room_id || service.room_id === null)) {
                  hasInvalidService = true;
                }
              });

              if (hasInvalidService) {
                toast.warning("Lütfen her hizmet için personel veya oda seçiniz!");
                return;
              }

              const newPacket = [];
              const CleanArray = Object.keys(new_package.services).map(
                (key) => new_package.services[key]
              );
              const staffs = [];
              CleanArray.map((item) => {
                const uniqueKey = `${item?.staff_id}_${item?.room_id}_${item?.packet_id}`;
                if (staffs.includes(uniqueKey) === false) {
                  staffs.push(uniqueKey);
                  newPacket.push(item);
                }
              });
              setSaveButtonDisabled(true);

              const fPacket = newPacket.map((item) => ({
                ...item,
                amount: `${CleanArray.filter(
                  (el) =>
                    el.staff_id === item.staff_id &&
                    el.room_id === item.room_id &&
                    el.packet_id === item.packet_id
                )
                  .map((el) => el.amount * el.period)
                  .reduce((a, b) => a + b, 0)}`,
              }));

              validatePackage() &&
                Axios.post(
                  `${context.api_endpoint}/company/packet/to/receipt`,
                  {
                    receipt_id: parseInt(paramsId),
                    process_date:
                      new_package?.services[1]?.period_start,
                    services: [],
                    packets: fPacket
                      .filter((item) => item !== undefined)
                      .map((data_packet) => {
                        return {
                          process_date: data_packet?.period_start,
                          staff_id: data_packet?.staff_id,
                          room_id: data_packet?.room_id || null,
                          amount: parseInt(data_packet?.amount),
                          packet_id: data_packet?.packet_id,
                          note: data_packet?.note ?? "",
                          name: data_packet?.name,
                          services: [
                            ...Object.keys(new_package.services)
                              .filter(
                                (key) =>
                                  new_package.services[key] !== undefined &&
                                  new_package.services[key].staff_id ===
                                  data_packet?.staff_id &&
                                  new_package.services[key].room_id ===
                                  data_packet?.room_id &&
                                  new_package.services[key].packet_id ===
                                  data_packet?.packet_id
                              )
                              .map((item) =>
                                Object.assign(
                                  {
                                    service_id:
                                      new_package?.services[item]?.service_id,
                                    staff_id: new_package?.services[item]?.staff_id || null,
                                    room_id: new_package?.services[item]?.room_id || null,
                                    amount: new_package?.services[item]?.amount,
                                    period: new_package?.services[item]?.period,
                                    period_between:
                                      new_package?.services[item]
                                        ?.period_between,
                                    period_start:
                                      new_package?.services[item]?.period_start,
                                    process_type: 1,
                                  },
                                  {}
                                )
                              ),
                          ],
                        };
                      }),
                  }
                )
                  .then((response) => {
                    const {
                      data: { data },
                    } = response;
                    if (response.status === 201) {
                      getSingleReceipt();
                      setSaveButtonDisabled(false);
                      setPackageSaleModal(false);
                      setNewPackage({
                        services: {}
                      });
                      set__Package(null);
                      toast.success(
                        context.t(
                          `receipt/detail/id.packageSale.packageSaleSuccess`
                        )
                      );
                    }
                  })
                  .catch((e) => {
                    if (e.response.status === 401) {
                      toast.error(e.response.data.message);
                    }
                  });
            }}
          />
        )}
    </AlertDialog>
  );
};

/**
 * Paket satışının yapıldığı, verilerin düzenlendiği alan.
 */
export const _PackageSalesBuilder = ({
  checkout_data,
  setCheckoutData,
  packageChanges,
  setPackageChanges,
  getTotalAmounts,
  setPackageDetailDialogModal,
  setPackageSaleModal,
  setSelectedPackageUpdateDate,
  setSelectedPackageTransitionId,
  selected_package_transition_update_state,
  setSelectedPackageTransitionUpdateState,
  setServicesUpdateDateModal,
  services_update_date_modal,
  services_update_modal,
  setServicesUpdateModal,
  setPackageUpdateDate,
  packet_detail_array1,
  setPacketDetailArray1,
  staffs,
  rooms,
  services,
  customer_s,
  setIsChange,
  is_package,
  setCheckoutDataDialog,
  setSelectedReceiptId,
  setSelectedTime,
  setSelectedDate,
  setSelectedService,
  setSelectedStaff,
  setDiscountTarget,
  setDiscountType,
  setDiscountValue,
  setDiscountModal,
  setTransictionsToState,
  setTransictionsToDate,
  package_delete_modal,
  setPackageDeleteModal,
  last_services_from_package_to_delete_modal,
  setLastServicesFromPackageToDeleteModal,
  delete_package_id,
  setDeletedPackages,
  setDeletedPackagesServicesTransactionPackageId,
  lateCheckout,
  setLateCheckout,
  getSingleReceipt,
  singlePaymentAndInstallmentPayment,
  advanced_date,
  advanced_type,
  setAdvancedDate,
  setAdvancedType,
  advanced_staff,
  setAdvancedStaff,
  setPaymentSelectStaff,
  payment_select_staff,
  advanced_amount,
  setAdvancedAmount,
  hasUnsavedChanges,
  setHasUnsavedChanges,
  is_change,
  saveSingleReceipt,
  lastSaveTimestamp,
  setLastSaveTimestamp
}) => {
  const context = useContext(AppContext);
  let total_mount = 0;
  const rounded_amount = getTotalAmounts().packages;
  const history = useHistory()

  let amountData = Object.keys(checkout_data.packages).map((key) =>
    checkout_data.packages[key] !== undefined
      ? checkout_data.packages[key].amount !== NaN
        ? checkout_data.packages[key].amount
        : 0
      : 0
  );

  for (let i = 0; i < amountData.length - 1; i++) {
    total_mount += amountData[i];
  }

  for (let j = 0; j < amountData.length; j++) {
    amountData[j] = amountData[j];
    if (amountData[amountData.length - 1]) {
      amountData[amountData.length - 1] = rounded_amount - total_mount;
    }
  }
  const [selectedStaff, setSelectedStaffPayment] = useState(null);
  const [installment_dialog, setInstallmentDialog] = useState(false);
  const [addPayment_dialog, setAddPaymentDialog] = useState(false);
  const [installment_date, setInstallmentDate] = useState(null);
  const [selected_installment, setSelectedInstallment] = useState(null);
  const [selected, setSelected] = useState(null);
  const [appointmentDetailModal, setAppointmentDetailModal] = useState(false);
  const [_appointment, set_Appointment] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [shortCode, setShortCode] = useState(null);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [weeklyAppointments, setWeeklyAppointments] = useState([]);
  const [hourDetail, setHourDetail] = useState({
    start_hour: context.state.company_shift.start_hour,
    end_hour: context.state.company_shift.end_hour,
  });
  const [selectedStaffs, setSelectedStaffs] = useState(null);
  const [timeUpgrade, setTimeUpgrade] = useState(null);
  const [skipRefresh, setSkipRefresh] = useState(false);
  const [createAppointmentModal, setCreateAppointmentModal] = useState(false);

  const [loaded, setLoaded] = useState(false);
  const [selectedStaffArr, setSelectedStaffArr] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  // TRANSACTION=1 (seans), PACKAGE=2 (paket), STOCK_ITEM=3
  const [paymentReceiptType, setPaymentReceiptType] = useState(2);

  const [saveCashDialogOpen, setSaveCashDialogOpen] = useState(false);
  const [saveCreditDialogOpen, setSaveCreditDialogOpen] = useState(false);

  const preparePaymentForm = (item, receiptType) => {
    setPaymentReceiptType(receiptType);
    setSelectedId(item?.id);
    setSelected(item ? { [item.id]: item } : {});

    const staffId = item?.staff_id ? parseInt(item.staff_id) : null;
    if (staffId) {
      const staff = staffs?.find((s) => parseInt(s.id) === staffId) || null;
      setAdvancedStaff(staff);
      setPaymentSelectStaff({ staff_id: staffId });
      setSelectedStaffPayment(staffId);
    } else {
      setAdvancedStaff(null);
      setPaymentSelectStaff({});
      setSelectedStaffPayment(null);
    }

    const amount = Math.round(parseFloat(item?.amount || 0));
    setAdvancedAmount(amount > 0 ? amount : null);
  };

  // Component unmount olurken dialog'ları kapat
  useEffect(() => {
    return () => {
      setSaveCashDialogOpen(false);
      setSaveCreditDialogOpen(false);
    };
  }, []);

  const getInstallmentDiffTotal = (count) => {
    try {
      // Get the first package from selected
      const firstPackage = Object.values(selected || {})[0];
      console.log('getInstallmentDiffTotal - firstPackage:', firstPackage);

      if (!firstPackage) {
        console.warn('getInstallmentDiffTotal - No package selected');
        return 0;
      }

      // Get the receipt_package_id from the first package
      const receiptPackageId = firstPackage.receipt_package_id;
      console.log('getInstallmentDiffTotal - receiptPackageId:', receiptPackageId);

      // Find the receipt package in checkout_data.groups
      const receiptPackage = checkout_data.groups.find(group => group.id === receiptPackageId);
      console.log('getInstallmentDiffTotal - receiptPackage:', receiptPackage);

      if (!receiptPackage) {
        console.warn('getInstallmentDiffTotal - No receipt package found');
        return 0;
      }

      // Return the total amount divided by the number of installments
      return (receiptPackage.amount || 0) / count;
    } catch (error) {
      console.error('getInstallmentDiffTotal - Error:', error);
      return 0;
    }
  };

  const getInstallmentTotal = (count) => {
    try {
      // Get the first package from selected
      const firstPackage = Object.values(selected || {})[0];
      console.log('getInstallmentTotal - firstPackage:', firstPackage);

      if (!firstPackage) {
        console.warn('getInstallmentTotal - No package selected');
        return 0;
      }

      // Get the receipt_package_id from the first package
      const receiptPackageId = firstPackage.receipt_package_id;
      console.log('getInstallmentTotal - receiptPackageId:', receiptPackageId);

      // Find the receipt package in checkout_data.groups
      const receiptPackage = checkout_data.groups.find(group => group.id === receiptPackageId);
      console.log('getInstallmentTotal - receiptPackage:', receiptPackage);

      if (!receiptPackage) {
        console.warn('getInstallmentTotal - No receipt package found');
        return 0;
      }

      // Return the total amount
      return receiptPackage.amount || 0;
    } catch (error) {
      console.error('getInstallmentTotal - Error:', error);
      return 0;
    }
  };

  const getAppointment = async (appointment_id) => {
    try {
      const { data } = await Axios.get(`${context.api_endpoint}/company/appointments/${appointment_id}`);

      if (data) {
        // Randevu verilerini set et
        setHourDetail({
          start_hour: moment(
            data.appointment_start_date
          ).format("HH:mm"),
          end_hour: moment(
            data.appointment_end_date
          ).format("HH:mm"),
        });
        set_Appointment(data);

        setAppointmentDate(
          data.appointment_start_date
        );
        setSelectedStaffs(data.staff);
        setCreateAppointmentModal(true);
        try {
          const response = await Axios.get(
            `${context.api_endpoint}/company/shortcode/list/keyword`
          );
          if (response.status === 200) {
            setShortCode(response.data.data.keyword);
          }
        } catch (error) {
          console.error("Error fetching shortcode:", error);
        }

        try {
          const { data } = await Axios.get(
            `${context.api_endpoint}/company/sms/template/all`
          );
          setSmsTemplates([...data.data]);
        } catch (error) {
          console.error("Error fetching SMS templates:", error);
        }

      }
    } catch (error) {
      console.error("Randevu detayları alınamadı:", error);
      toast.error(context.t("appointments.getAppointmentError"));
    }
  };
  const getAppointmentsForSelectBox = async () => {

  };

  const updateAppointmentState = async (appointmentId, customerState) => {
    await Axios.put(
      `${context.api_endpoint}/company/appointment/customer/state`,
      {
        appointment_id: appointmentId,
        customer_state: customerState,
      }
    )
      .then((response) => {
        if (response.status === 200) {
          getAppointmentsForSelectBox();
          toast.success(
            context.t(
              `appointments.detail.appointmentStatus.changeStatusSuccessToast`
            )
          );
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          toast.error(e.response.data.message);
        } else {
          toast.warning(e.response.data.message);
        }
      });
  };

  useEffect(() => {
    setLateCheckout(checkout_data)
  }, [checkout_data])

  const inputRef = useRef();


  useEffect(() => {
    if (is_change === true) {
      saveSingleReceipt();
      // Adisyon kaydedildiğinde, kaydedilmemiş değişiklikler işaretini temizle
      setHasUnsavedChanges(false);
      setSaveCashDialogOpen(false);
      setSaveCreditDialogOpen(false);
      setInstallmentDialog(true);
      setAddPaymentDialog(true);
    }
  }, [is_change, saveSingleReceipt, setHasUnsavedChanges]);

  // Ödeme işlemlerini yapmadan önce değişiklikleri kontrol eden fonksiyon
  const checkUnsavedChangesBeforePayment = (callback) => {
    // Son kaydetme işleminden sonra 10 saniye geçmiş mi kontrol et
    const isRecentlySaved = lastSaveTimestamp && (Date.now() - lastSaveTimestamp) < 10000;

    if (hasUnsavedChanges && !isRecentlySaved) {
      setSaveCashDialogOpen(true);
    } else {
      callback();
    }
  };
  const checkUnsavedChangesBeforePaymentCredit = (callback) => {
    // Son kaydetme işleminden sonra 10 saniye geçmiş mi kontrol et
    const isRecentlySaved = lastSaveTimestamp && (Date.now() - lastSaveTimestamp) < 10000;

    if (hasUnsavedChanges && !isRecentlySaved) {
      setSaveCreditDialogOpen(true);
    } else {
      callback();
    }
  };

  // Adisyonu kaydet ve sonra callback'i çalıştır
  const saveReceiptAndContinue = (callback) => {
    saveSingleReceipt();
    setSaveCashDialogOpen(false);
    setSaveCreditDialogOpen(false);
    setLastSaveTimestamp(Date.now());
    setAddPaymentDialog(true)
    setHasUnsavedChanges(false);
    if (callback) {
      callback();
    }
  };

  const saveReceiptAndContinueCredit = (callback) => {
    saveSingleReceipt();
    setSaveCashDialogOpen(false);
    setSaveCreditDialogOpen(false);
    setLastSaveTimestamp(Date.now());
    setInstallmentDialog(true)
    setHasUnsavedChanges(false);
    if (callback) {
      callback();
    }
  };

  return (
    <SectionBox style={{ overflowX: "hidden" }}>
      <AppointmentCardDetail
        _appointment={_appointment}
        set_Appointment={set_Appointment}
        updateAppointmentState={updateAppointmentState}
        setAppointmentDetailModal={setAppointmentDetailModal}
        setCreateAppointmentModal={setCreateAppointmentModal}
        appointmentDetailModal={appointmentDetailModal}
        hourDetail={hourDetail}
        setHourDetail={setHourDetail}
        weeklyAppointments={weeklyAppointments}
        timeUpgrade={timeUpgrade}
        setTimeUpgrade={setTimeUpgrade}
        selectedStaff={selectedStaffs}
        getAppointmentsForSelectBox={getAppointmentsForSelectBox}
        setAppointmentDate={setAppointmentDate}
        appointmentDate={appointmentDate}
        shortCode={shortCode}
        smsTemplates={smsTemplates}
        setSkipRefresh={setSkipRefresh}
        isReceiptPackage={true}
        getSingleReceipt={getSingleReceipt}
      />
      <SectionHeading
        style={{
          backgroundColor: "rgba(140,15,180, 0.1)",
          color: "#8c0fb4",
          border: "1px solid #8c0fb4",
          padding: "10px",
          borderRadius: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div className="detail-search" style={{ backgroundColor: "#8c0fb4" }}>
          <Search
            style={{ color: "white", fontSize: "20px" }}
            onClick={() => setPackageDetailDialogModal(true)}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ShoppingBasket />
          <h3 style={{ marginLeft: "15px" }}>
            {context.t(
              `['receipt/detail/id'].serviceTransactions.packageTitle`
            )}
          </h3>
        </div>
        <div>
          <AddBox
            style={{ cursor: "pointer", fontSize: "36px" }}
            onClick={() => setPackageSaleModal(true)}
          />
        </div>
      </SectionHeading>

      <ListSection className="no-scroll-bar">
        {checkout_data.groups
          .filter((el) => el !== undefined)
          .map((data, indexGroup) => (
            <ReportsContainer
              key={indexGroup}
              style={{
                padding: "1.5em 0 0 0",
                transition: "all 0.3s ease",
                height: "auto",
              }}
            >
              <Column
                className="sx-12 sm-12 md-12 lg-12 group_header"
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Column className="xs-12 sm-12 md-12 lg-2">
                  <MuiThemeProvider theme={themeForDatePicker}>
                    <DatePickerInput
                      className="mb-1"
                      label={context.t(
                        `['receipt/detail/id'].serviceTransactions.packageDateInputLabel`
                      )}
                      error={false}
                      value={data.process_date ? moment(data.process_date).toISOString() : ""}
                      onChange={(date) => {
                        setSelectedPackageUpdateDate(moment(date).toISOString());
                        setSelectedPackageTransitionId(data.id)
                        setServicesUpdateDateModal(true);
                        setPackageUpdateDate(moment(date).diff(data.process_date, "days"));
                      }}
                    />
                  </MuiThemeProvider>
                </Column>
                <Column className="xs-12 sm-12 md-12 lg-3">
                  <ReportsHeader
                    onClick={() => {
                      if (
                        packet_detail_array1.includes(indexGroup)
                      ) {
                        setPacketDetailArray1(packet_detail_array1.filter((index) => index !== indexGroup));
                      } else {
                        setPacketDetailArray1([...packet_detail_array1, indexGroup]);

                      }
                    }}
                  >
                    <p
                      style={{ color: data.is_passive ? "red" : "black" }}
                    >{`${data.package_name}`}</p>
                    <p style={{ color: data.is_passive ? "red" : "black" }}>
                      &nbsp;
                      {`(${Object.keys(checkout_data.packages)
                        .filter(
                          (key) => checkout_data.packages[key] !== undefined
                        )
                        .filter(
                          (key) =>
                            checkout_data.packages[key]
                              .receipt_package_id === data.id
                        ).length
                        })`}
                    </p>
                  </ReportsHeader>
                </Column>

                {/* Personel Select - Sadece personel seçiliyse veya hiçbiri seçili değilse göster */}
                {(data.staff_id || !data.room_id) && (
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <StaffSelect
                      className="mb-1"
                      disabled={context.state.user.permission === 0}
                      label={context.t(
                        `['receipt/detail/id'].serviceTransactions.staffInputLabel`
                      )}
                      items={staffs}
                      selected={data.staff_id ? data.staff_id : ""}
                      labelKey="full_name"
                      valueKey="id"
                      handler={(staff_id) => {
                        setCheckoutData({
                          ...checkout_data,
                          groups: [
                            ...checkout_data.groups.map((item) =>
                              item.id === data.id
                                ? { ...item, staff_id: parseInt(staff_id), room_id: null }
                                : { ...item }
                            ),
                          ],
                          groupsAmount: Object.assign(
                            {},
                            Object.values(
                              checkout_data.groupsAmount
                            ).map((item, index) =>
                              item.id === data.id
                                ? {
                                  ...item,
                                  staff_id: parseInt(staff_id),
                                  room_id: null,
                                }
                                : { ...item }
                            )
                          ),
                          packages: Object.assign({}, [
                            ...Object.values(
                              checkout_data.packages
                            ).filter(
                              (item) => item.receipt_package_id !== data.id
                            ),
                            ...Object.values(
                              checkout_data.packages
                            )
                              .filter(
                                (item) => item.receipt_package_id === data.id
                              )
                              .map((item, key) => ({
                                ...item,
                                staff_id: parseInt(staff_id),
                                room_id: null,
                              })),
                          ]),
                        });
                        setPackageChanges(true);
                      }}
                    />
                  </Column>
                )}

                {/* Oda Select - Sadece oda seçiliyse veya hiçbiri seçili değilse göster */}
                {(data.room_id || !data.staff_id) && (
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Select
                      className="mb-1"
                      disabled={context.state.user.permission === 0}
                      label="Oda"
                      items={(rooms || [])
                        .filter(room => room && (room.ID || room.id))
                        .map(room => ({
                          id: room.ID || room.id,
                          name: room.Name || room.name,
                          backgroundColor: '',
                          color: ''
                        }))}
                      selected={data.room_id ? data.room_id : ""}
                      labelKey="name"
                      valueKey="id"
                      title={
                        rooms && data.room_id
                          ? rooms.find(r => (r.ID || r.id) === data.room_id)?.Name ||
                          rooms.find(r => (r.ID || r.id) === data.room_id)?.name || ""
                          : ""
                      }
                      handler={(room_id) => {
                        setCheckoutData({
                          ...checkout_data,
                          groups: [
                            ...checkout_data.groups.map((item) =>
                              item.id === data.id
                                ? { ...item, room_id: parseInt(room_id), staff_id: null }
                                : { ...item }
                            ),
                          ],
                          groupsAmount: Object.assign(
                            {},
                            Object.values(
                              checkout_data.groupsAmount
                            ).map((item, index) =>
                              item.id === data.id
                                ? {
                                  ...item,
                                  room_id: parseInt(room_id),
                                  staff_id: null,
                                }
                                : { ...item }
                            )
                          ),
                          packages: Object.assign({}, [
                            ...Object.values(
                              checkout_data.packages
                            ).filter(
                              (item) => item.receipt_package_id !== data.id
                            ),
                            ...Object.values(
                              checkout_data.packages
                            )
                              .filter(
                                (item) => item.receipt_package_id === data.id
                              )
                              .map((item, key) => ({
                                ...item,
                                room_id: parseInt(room_id),
                                staff_id: null,
                              })),
                          ]),
                        });
                        setPackageChanges(true);
                      }}
                    />
                  </Column>
                )}

                <Column
                  className="xs-12 sm-12 md-12 lg-3"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                  }}
                >
                  <InfoCard
                    style={{
                      backgroundColor: "rgba(249,186,132, 0.21)",
                      border: "1px solid rgba(249,186,132, 0.51)",
                      color: "rgb(219,146,92)",
                    }}
                    onClick={async () => {
                      await setSelectedPackageTransitionId(data.id);
                      await setSelectedPackageTransitionUpdateState(2);
                      await setServicesUpdateModal(true);
                    }}
                  >
                    <InfoCardText>
                      <span>
                        {
                          Object.keys(checkout_data.packages)
                            .filter(
                              (key) =>
                                checkout_data.packages[key] !== undefined
                            )
                            .filter(
                              (key) =>
                                checkout_data.packages[key]
                                  .receipt_package_id === data.id &&
                                checkout_data.packages[key].customer_state ===
                                2
                            ).length
                        }
                      </span>
                      <img src={Waiting} alt="waiting" />
                    </InfoCardText>
                  </InfoCard>

                  <InfoCard
                    style={{
                      backgroundColor: "rgb(29, 139, 62, 0.21)",
                      border: "1px solid rgb(58, 154, 87, 0.35)",
                      color: "rgb(29, 139, 62)",
                    }}
                    onClick={async () => {
                      await setSelectedPackageTransitionId(data.id);
                      await setSelectedPackageTransitionUpdateState(0);
                      await setServicesUpdateModal(true);
                    }}
                  >
                    <InfoCardText>
                      <span>
                        {
                          Object.keys(checkout_data.packages)
                            .filter(
                              (key) =>
                                checkout_data.packages[key] !== undefined
                            )
                            .filter(
                              (key) =>
                                checkout_data.packages[key]
                                  .receipt_package_id === data.id &&
                                checkout_data.packages[key].customer_state ===
                                0
                            ).length
                        }
                      </span>
                      <img src={HomeChcek} alt="home-check" />
                    </InfoCardText>
                  </InfoCard>

                  <InfoCard
                    style={{
                      backgroundColor: "rgb(254, 151, 151, 0.19)",
                      border: "1px solid rgb(185, 178, 178, 0.65)",
                      color: "rgb(254, 111, 111)",
                    }}
                    onClick={async () => {
                      await setSelectedPackageTransitionId(data.id);
                      await setSelectedPackageTransitionUpdateState(1);
                      await setServicesUpdateModal(true);
                    }}
                  >
                    <InfoCardText>
                      <span>
                        {
                          Object.keys(checkout_data.packages)
                            .filter(
                              (key) =>
                                checkout_data.packages[key] !== undefined
                            )
                            .filter(
                              (key) =>
                                checkout_data.packages[key]
                                  .receipt_package_id === data.id &&
                                checkout_data.packages[key].customer_state ===
                                1
                            ).length
                        }
                      </span>
                      <img src={NotCome} alt="note-come" />
                    </InfoCardText>
                  </InfoCard>
                </Column>

                <Column className="xs-12 sm-12 md-12 lg-2">
                  <MaskedInput
                    className="mb-1"
                    label={
                      context.t(
                        `['receipt/detail/id'].serviceTransactions.amountInputLabel`
                      ) +
                      (context.state.currency
                        ? " (" + context.state.currency + ")"
                        : "(₺)")
                    }
                    // context.state.currency ? context.state.currency : "₺"
                    mask="9999999999999"
                    maskChar=""
                    disabled={false}
                    value={Math.round(
                      checkout_data.groupsAmount[indexGroup].amount !== null
                        ? checkout_data.groupsAmount[indexGroup].amount
                        : ""
                    )}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (!/^[0-9.,]*$/.test(inputValue) && inputValue !== "") {
                        return;
                      }

                      const numericValue = inputValue.replace(/\./g, '').replace(',', '.');
                      const newTotalAmount = parseFloat(numericValue) || 0;

                      const sessionPackages = Object.entries(checkout_data.packages)
                        .filter(([k, pkg]) =>
                          pkg !== undefined &&
                          pkg.receipt_package_id === data.id &&
                          pkg.process_type === 1
                        );

                      if (sessionPackages.length === 0) return;

                      const originalTotal = sessionPackages.reduce(
                        (sum, [_, pkg]) => sum + (pkg.first_amount || 0),
                        0
                      );

                      if (originalTotal <= 0) {
                        if (newTotalAmount <= 0) {
                          const updatedPackages = { ...checkout_data.packages };
                          sessionPackages.forEach(([key, pkg]) => {
                            updatedPackages[key] = {
                              ...pkg,
                              amount: 0
                            };
                          });

                          const updatedGroups = [...checkout_data.groups];
                          const updatedGroupsAmount = { ...checkout_data.groupsAmount };

                          if (updatedGroupsAmount[indexGroup]) {
                            updatedGroupsAmount[indexGroup] = {
                              ...updatedGroupsAmount[indexGroup],
                              amount: 0
                            };
                          }

                          const groupIndex = updatedGroups.findIndex(group => group.id === data.id);
                          if (groupIndex !== -1) {
                            updatedGroups[groupIndex] = {
                              ...updatedGroups[groupIndex],
                              amount: 0
                            };
                          }

                          setCheckoutData({
                            ...checkout_data,
                            groupsAmount: updatedGroupsAmount,
                            groups: updatedGroups,
                            packages: updatedPackages
                          });

                          setPackageChanges(true);
                          setHasUnsavedChanges(true);
                        }
                        return;
                      }

                      const updatedPackages = { ...checkout_data.packages };

                      let distributedTotal = 0;

                      sessionPackages.slice(1).forEach(([key, pkg]) => {
                        const originalRatio = pkg.first_amount / originalTotal;
                        const newAmount = Math.floor(newTotalAmount * originalRatio);
                        updatedPackages[key] = {
                          ...pkg,
                          amount: newAmount
                        };
                        distributedTotal += newAmount;
                      });

                      if (sessionPackages.length > 0) {
                        const [firstKey, firstPkg] = sessionPackages[0];
                        const remainingAmount = newTotalAmount - distributedTotal;

                        updatedPackages[firstKey] = {
                          ...firstPkg,
                          amount: remainingAmount
                        };
                      }

                      const updatedGroups = [...checkout_data.groups];
                      const updatedGroupsAmount = { ...checkout_data.groupsAmount };

                      if (updatedGroupsAmount[indexGroup]) {
                        updatedGroupsAmount[indexGroup] = {
                          ...updatedGroupsAmount[indexGroup],
                          amount: newTotalAmount
                        };
                      }

                      const groupIndex = updatedGroups.findIndex(group => group.id === data.id);
                      if (groupIndex !== -1) {
                        updatedGroups[groupIndex] = {
                          ...updatedGroups[groupIndex],
                          amount: newTotalAmount
                        };
                      }

                      setCheckoutData({
                        ...checkout_data,
                        groupsAmount: updatedGroupsAmount,
                        groups: updatedGroups,
                        packages: updatedPackages
                      });
                      setPackageChanges(true);
                      setHasUnsavedChanges(true);
                    }}
                  />
                </Column>
                <Column className="xs-12 sm-12 md-12 lg-auto">
                  {!data.button_passive && (
                    <Column style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "start", gap: "10px", height: "100%" }}>
                      <img src={Credit} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                        checkUnsavedChangesBeforePaymentCredit(() => {
                          setInstallmentDialog(true);
                          setInstallmentDate(true)
                        });
                        const packageData = Object.values(checkout_data?.groupsAmount || {}).find(
                          pkg => pkg?.id === data?.id
                        );
                        preparePaymentForm(
                          { ...packageData, staff_id: packageData?.staff_id || data?.staff_id },
                          2
                        );
                      }} />
                      <img src={Cash} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                        checkUnsavedChangesBeforePayment(() => {
                          setAddPaymentDialog(true);
                          setInstallmentDate(false)
                        });
                        const packageData = Object.values(checkout_data?.groupsAmount || {}).find(
                          pkg => pkg?.id === data?.id
                        );
                        preparePaymentForm(
                          { ...packageData, staff_id: packageData?.staff_id || data?.staff_id },
                          2
                        );
                      }} />
                      <AlertDialog
                        title={
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <Warning style={{ color: "#FFA500", marginRight: "10px" }} />
                            <span>Adisyonu Kaydetmediniz</span>
                          </div>
                        }
                        open={saveCashDialogOpen}
                        fullWidth
                        maxWidth="xs"
                        closeHandler={() => setSaveCashDialogOpen(false)}
                        buttons={[
                          {
                            title: "Kaydet ve Devam Et",
                            icon: "check",
                            backgroundColor: "green",
                            validationButton: true,
                            style: { height: "56px" },
                            textColor: "white",
                            onClick: () => saveReceiptAndContinue(),
                          },
                          {
                            title: "İptal",
                            icon: "close",
                            backgroundColor: "white",
                            style: {
                              border: "1px solid #666666",
                              height: "56px",
                            },
                            textColor: "black",
                            onClick: () => setSaveCashDialogOpen(false),
                          },
                        ]}
                      >
                        <p>Fiyat değişikliği yaptınız ancak adisyonu kaydetmediniz. Devam etmeden önce kaydetmek ister misiniz?</p>
                      </AlertDialog>
                      <AlertDialog
                        title={
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <Warning style={{ color: "#FFA500", marginRight: "10px" }} />
                            <span>Adisyonu Kaydetmediniz</span>
                          </div>
                        }
                        open={saveCreditDialogOpen}
                        fullWidth
                        maxWidth="xs"
                        closeHandler={() => setSaveCreditDialogOpen(false)}
                        buttons={[
                          {
                            title: "Kaydet ve Devam Et",
                            icon: "check",
                            backgroundColor: "green",
                            validationButton: true,
                            style: { height: "56px" },
                            textColor: "white",
                            onClick: () => saveReceiptAndContinueCredit(),
                          },
                          {
                            title: "İptal",
                            icon: "close",
                            backgroundColor: "white",
                            style: {
                              border: "1px solid #666666",
                              height: "56px",
                            },
                            textColor: "black",
                            onClick: () => setSaveCreditDialogOpen(false),
                          },
                        ]}
                      >
                        <p>Fiyat değişikliği yaptınız ancak adisyonu kaydetmediniz. Devam etmeden önce kaydetmek ister misiniz?</p>
                      </AlertDialog>

                      <AlertDialog
                        title={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "5px",
                            }}
                          >
                            <AddOutlined
                              style={{
                                color: "#6097D2",
                              }}
                            />
                            <span
                              style={{
                                color: "#6097D2",
                              }}
                            >
                              {context.t(`['receipt/detail/id'].addPaymentTitle`)}
                            </span>
                          </div>
                        }
                        open={addPayment_dialog}
                        fullWidth
                        maxWidth="xs"
                        closeHandler={() => setAddPaymentDialog(false)}
                        buttons={[
                          {
                            title: context.t(
                              `appointments.create.completePaymentButtonTitle`
                            ),
                            icon: "check",
                            backgroundColor: "green",
                            style: {
                              height: "56px",
                            },
                            textColor: "white",
                            onClick: () => {
                              if (!advanced_date || !advanced_amount || advanced_amount <= 0) {
                                toast.error('Lütfen tüm alanları doldurunuz!');
                                return;
                              }
                              // Make API request to add payment
                              const paymentData = {
                                receipt_id: parseInt(data?.receipt_id),
                                id: parseInt(selectedId),
                                receipt_type: paymentReceiptType,
                                is_installment: false,
                                payments: [{
                                  payment_date: moment(advanced_date).toISOString(),
                                  payment_type: advanced_type,
                                  staff_id: payment_select_staff?.staff_id
                                    ? parseInt(payment_select_staff.staff_id)
                                    : null,
                                  amount: parseFloat(advanced_amount),
                                  payment_status: 0
                                }]
                              };

                              singlePaymentAndInstallmentPayment(paymentData);

                              // Clear form fields
                              setAddPaymentDialog(false);
                              setAdvancedAmount(null);
                              setAdvancedDate(new Date());
                              setAdvancedType(0);
                              setAdvancedStaff(null);
                              setPaymentSelectStaff({});
                              setAddPaymentDialog(false)
                            },
                          },
                          {
                            title: context.t(`appointments.create.discardButtonTitle`),
                            icon: "close",
                            backgroundColor: "white",
                            style: {
                              border: "1px solid #666666",
                              height: "56px",
                            },
                            textColor: "black",
                            onClick: () => {
                              setAddPaymentDialog(false);
                              setPaymentSelectStaff({});
                              setAdvancedStaff(null);
                              setAdvancedAmount(null);
                              setAdvancedDate(new Date());
                              setAdvancedType(0);
                            },
                          },
                        ]}
                      >
                        <>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
                            </span>
                            <DatePickerInput
                              // label={context.t(
                              //   `['receipt/detail/id'].payments.dateInputLabel`
                              // )}
                              value={moment(advanced_date).local().toISOString() || new Date()}
                              onChange={(payment_date) => {
                                setAdvancedDate(payment_date);
                              }}
                            />
                          </Column>
                          <Column>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <AdvancedType
                                style={{
                                  backgroundColor: advanced_type == 0 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 0
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 0
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => setAdvancedType(0)}
                              >
                                {advanced_type == 0 ? (
                                  <img src={CashWhite} alt="cash_white" />
                                ) : (
                                  <img src={Cash} alt="cash" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 0 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`accounting.typeCASH`)}
                                </span>
                              </AdvancedType>
                              <AdvancedType
                                style={{
                                  marginLeft: "10px",
                                  backgroundColor: advanced_type == 2 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 2
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 2
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => {
                                  setAdvancedType(2);
                                }}
                              >
                                {advanced_type == 2 ? (
                                  <img src={TransferWhite} alt="transfer_white" />
                                ) : (
                                  <img src={Transfer} alt="transfer" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 2 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`accounting.typeEFT`)}
                                </span>
                              </AdvancedType>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <AdvancedType
                                style={{
                                  backgroundColor: advanced_type == 1 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 1
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 1
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => {
                                  setAdvancedType(1);
                                }}
                              >
                                {advanced_type == 1 ? (
                                  <img src={CreditWhite} alt="credit_white" />
                                ) : (
                                  <img src={Credit} alt="credit" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 1 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`accounting.typeCARD`)}
                                </span>
                              </AdvancedType>
                              <AdvancedType
                                style={{
                                  marginLeft: "10px",
                                  backgroundColor: advanced_type == 3 ? "#78B8FF" : "#FFFFFF",
                                  filter:
                                    advanced_type == 3
                                      ? "drop-shadow(0px 3px 6px #78B8FF)"
                                      : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                  border:
                                    advanced_type == 3
                                      ? "1px solid #6BB0FE"
                                      : "1px solid #b8b8b8",
                                }}
                                onClick={() => {
                                  setAdvancedType(3);
                                }}
                              >
                                {advanced_type == 3 ? (
                                  <img src={CustomerPointWhite} alt="customer_point_white" />
                                ) : (
                                  <img src={CustomerPoint} alt="customer_point" />
                                )}
                                <span
                                  style={{
                                    color: advanced_type == 3 ? "#FFFFFF" : "#000000",
                                  }}
                                >
                                  {context.t(`["accounting/expense"].payments.cusPoint`)}
                                </span>
                              </AdvancedType>
                            </div>
                          </Column>
                          <Column>
                            <StaffSelect
                              disabled={context.state.user.permission === 0}
                              label={payment_select_staff?.room_id ? payment_select_staff?.room_name : context.t(`["receipt/detail/id"].selectStaff`)}
                              items={staffs}
                              selected={payment_select_staff?.staff_id}
                              labelKey="full_name"
                              valueKey="id"
                              returnFullObject
                              optional
                              handler={(staff) => {
                                if (!staff || !staff.id) {
                                  setAdvancedStaff(null);
                                  setPaymentSelectStaff({});
                                  return;
                                }
                                setAdvancedStaff(staff);
                                setPaymentSelectStaff({
                                  ...payment_select_staff,
                                  staff_id: parseInt(staff.id),
                                });
                              }}
                            />
                          </Column>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].paymentAmount`)} *
                            </span>
                            <MaskedInput
                              // label={"Ödeme Tutarı"}
                              mask="9999999999999"
                              maskChar=""
                              value={advanced_amount ? advanced_amount : ""}
                              onChange={(e) => {
                                setAdvancedAmount(e.target.value);
                              }}
                            />
                          </Column>
                        </>
                      </AlertDialog>
                      <AlertDialog
                        title={
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <span
                              style={{
                                width: "120%",
                                marginTop: "15px",
                              }}
                            >
                              {context.t(`['receipt/detail/id'].installmentProcess`)}
                            </span>
                            <CustomerBoxDiv>
                              {selected?.amount === 0 ? (
                                <img src={RemainingDebt} alt="remaining_debt" />
                              ) : (
                                <img src={RemainingDebtRed} alt="remaining_debt_red" />
                              )}
                              <CustomerPointBox>
                                <span>
                                  {getInstallmentDiffTotal(1)}{" "}
                                  {context.state.currency ? context.state.currency : "₺"}
                                </span>
                                <h3>{context.t(`['receipt/detail/id'].remainingDebt`)}</h3>
                              </CustomerPointBox>
                            </CustomerBoxDiv>
                          </div>
                        }
                        open={installment_dialog}
                        closeHandler={() => setInstallmentDialog(false)}
                        fullWidth
                        maxWidth="sm"
                        buttons={[
                          {
                            title: context.t(`appointments.create.completeButtonTitle`),
                            icon: "check",
                            backgroundColor: "green",
                            validationButton: true,
                            style: {
                              height: "56px",
                            },
                            textColor: "white",
                            onClick: () => {
                              if (!installment_date || !selected_installment) {
                                toast.error('Lütfen tüm alanları doldurunuz!');
                                return;
                              }
                              singlePaymentAndInstallmentPayment({
                                receipt_id: parseInt(data?.receipt_id),
                                id: parseInt(selectedId),
                                receipt_type: paymentReceiptType,
                                is_installment: true,
                                payments: Array.from({ length: selected_installment }, (_, i) => ({
                                  payment_date:
                                    i === 0
                                      ? moment(installment_date).toISOString()
                                      : moment(installment_date)
                                        .add(i, "months")
                                        .toISOString(),
                                  payment_type: 0,
                                  staff_id: selectedStaff ? parseInt(selectedStaff) : null,
                                  amount:
                                    getInstallmentDiffTotal(selected_installment),
                                  payment_status: 0,
                                }))
                              })
                              setSelected(null)
                              setSelectedInstallment(null)
                              setInstallmentDate(null)
                              setSelectedStaffPayment(null)
                              setAdvancedDate(new Date())
                              setAdvancedType(0)
                              setAdvancedStaff(null)
                              setInstallmentDialog(false)
                            },
                          },
                          {
                            title: context.t(`appointments.create.discardButtonTitle`),
                            icon: "close",
                            backgroundColor: "white",
                            style: {
                              border: "1px solid #666666",
                              height: "56px",
                            },
                            textColor: "black",
                            onClick: () => {
                              setInstallmentDialog(false);
                              setSelected(null);
                              setSelectedInstallment(null);
                              setInstallmentDate(null);
                              setSelectedStaffPayment(null);
                            },
                          },
                        ]}
                      >
                        <>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
                            </span>
                            <DatePickerInput
                              // label={context.t(
                              //   `['receipt/detail/id'].payments.dateInputLabel`
                              // )}
                              value={moment(installment_date).local().toISOString() || new Date()}
                              onChange={(payment_date) => {
                                setInstallmentDate(payment_date);
                              }}
                            />
                          </Column>
                          <Column>
                            <span
                              style={{
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].installmentStaffInputLabel`)} *
                            </span>
                            <StaffSelect
                              className="mb-1"
                              disabled={context.state.user.permission === 0}
                              label={selectedStaff?.room_id ? selectedStaff?.room_name : context.t(
                                `['receipt/detail/id'].serviceTransactions.staffInputLabel`
                              )}
                              items={staffs}
                              selected={selectedStaff ? selectedStaff : ""}
                              labelKey="full_name"
                              valueKey="id"
                              handler={(staff_id) => {
                                setSelectedStaffPayment(staff_id)
                              }}
                            />
                          </Column>
                          <Column>
                            <span
                              style={{
                                marginTop: '20px !important',
                                marginBottom: "10px",
                                marginLeft: "5px",
                                fontSize: "18px",
                              }}
                            >
                              {context.t(`["receipt/detail/id"].installmentCountInputLabel`)} *
                            </span>
                            <Select
                              // label={context.t(
                              //   `['receipt/detail/id'].installmentCountInputLabel`
                              // )}
                              labelKey="label"
                              valueKey="value"
                              items={[
                                { value: 2, label: context.t(`["receipt/detail/id"].installments.two`) },
                                { value: 3, label: context.t(`["receipt/detail/id"].installments.three`) },
                                { value: 4, label: context.t(`["receipt/detail/id"].installments.four`) },
                                { value: 5, label: context.t(`["receipt/detail/id"].installments.five`) },
                                { value: 6, label: context.t(`["receipt/detail/id"].installments.six`) },
                                { value: 7, label: context.t(`["receipt/detail/id"].installments.seven`) },
                                { value: 8, label: context.t(`["receipt/detail/id"].installments.eight`) },
                                { value: 9, label: context.t(`["receipt/detail/id"].installments.nine`) },
                                { value: 10, label: context.t(`["receipt/detail/id"].installments.ten`) },
                                { value: 11, label: context.t(`["receipt/detail/id"].installments.eleven`) },
                                { value: 12, label: context.t(`["receipt/detail/id"].installments.twelve`) },
                              ]}
                              selected={selected_installment ? selected_installment : null}
                              handler={(installment) => {
                                setSelectedInstallment(installment);
                              }}
                            />
                          </Column>
                          {selected_installment && (
                            <Column>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <p style={{ marginRight: "5px" }}>{context.t(`["receipt/detail/id"].payments.title`)}:</p>
                                <p>
                                  {Math.round(getInstallmentTotal(1) / selected_installment)}
                                  {context.state.currency
                                    ? context.state.currency
                                    : "₺"} x {selected_installment}
                                </p>
                              </div>
                            </Column>
                          )}
                        </>
                      </AlertDialog>
                    </Column>
                  )}
                </Column>

                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (
                      packet_detail_array1.includes(indexGroup)
                    ) {
                      setPacketDetailArray1(packet_detail_array1.filter(
                        (index) => index !== indexGroup
                      ))
                    } else {
                      setPacketDetailArray1([
                        ...packet_detail_array1,
                        indexGroup,
                      ])
                    }
                  }}
                >
                  {packet_detail_array1.includes(indexGroup) ? (
                    <ExpandLessIcon color="secondary" />
                  ) : (
                    <ExpandMoreIcon color="primary" />
                  )}
                </div>
              </Column>
              {packet_detail_array1.includes(indexGroup) && (
                <Column className="xs-12 sm-12 md-12 lg-12 mx-2">
                  {
                    //Paket Listesi
                    Object.keys(checkout_data.packages).filter(
                      (key) => checkout_data.packages[key] !== undefined
                    ).length > 0 ? (
                      Object.keys(checkout_data.packages)
                        .filter(
                          (key) =>
                            checkout_data.packages[key]
                              .transaction_package_id ===
                            data.transaction_package_id &&
                            checkout_data.packages[key].receipt_package_id ===
                            data.id
                        )
                        .map(
                          (key, indexSession) =>
                            checkout_data.packages[key].process_type ===
                            1 && (
                              <Grid
                                className="no-gutters-row"
                                key={indexSession}
                                style={{ position: 'relative' }}
                              >
                                {checkout_data.packages[key].process_date &&
                                  is_package && (
                                    <Column className="xs-12 sm-12 md-12 mt-1 lg-2">
                                      <MuiThemeProvider
                                        theme={themeForDatePicker}
                                      >
                                        <DatePickerInput
                                          className="mb-1"
                                          label={`${context.t(
                                            `['receipt/detail/id'].serviceTransactions.dateInputLabel`
                                          )} / ${indexSession + 1} Seans`}
                                          error={false}
                                          value={
                                            moment(
                                              checkout_data.packages[key]
                                                .process_date
                                            ).format("YYYY-MM-DD") ===
                                              "0001-01-01"
                                              ? null
                                              : moment(
                                                checkout_data.packages[key]
                                                  .process_date
                                              )
                                          }
                                          // disablePast
                                          onChange={(process_date) => {
                                            setCheckoutData({
                                              ...checkout_data,
                                              packages: {
                                                ...checkout_data.packages,
                                                [key]: {
                                                  ...checkout_data.packages[key],
                                                  process_date:
                                                    moment(process_date).format("YYYY-MM-DD"),
                                                },
                                              },
                                            });
                                            setPackageChanges(true);
                                          }}
                                        />
                                      </MuiThemeProvider>
                                    </Column>
                                  )}
                                <Column className="xs-12 sm-12 md-12 lg-2">
                                  <Select
                                    className="mb-1"
                                    label={context.t(
                                      `['receipt/detail/id'].serviceTransactions.nameInputLabel`
                                    )}
                                    title={
                                      services.filter(
                                        (item) =>
                                          item.id ===
                                          checkout_data.packages[key]
                                            .service_id
                                      ).length > 0
                                        ? services.filter(
                                          (item) =>
                                            item.id ===
                                            checkout_data.packages[key]
                                              .service_id
                                        )[0].name
                                        : context.t(`["receipt/detail/id"].deletedService`)
                                    }
                                    deletedService={staffs
                                      ?.filter(
                                        (staff) =>
                                          staff?.id ===
                                          lateCheckout?.packages[key]?.staff_id
                                      )[0]
                                      ?.services?.map((service) => service.service)?.includes(services.filter((el) => el.id === lateCheckout?.packages[key]?.service_id)?.map((data) => {
                                        return ({
                                          ...data,
                                          is_passive: true
                                        })
                                      })) ? [] : services?.filter((el) => el.id === lateCheckout?.packages[key]?.service_id)?.map((data) => {
                                        return ({
                                          ...data,
                                          is_passive: true
                                        })
                                      })}
                                    serviceDisabled={true}
                                    items={staffs
                                      ?.filter(
                                        (staff) =>
                                          staff.id ===
                                          checkout_data.packages[key].staff_id
                                      )[0]
                                      ?.services?.map(
                                        (service) => service?.service
                                      )}
                                    selected={
                                      checkout_data.packages[key].service_id
                                        ? services.filter(
                                          (item) =>
                                            item.id ===
                                            checkout_data.packages[key]
                                              .service_id
                                        ).length
                                          ? checkout_data.packages[key]
                                            .service_id
                                          : context.t(`["receipt/detail/id"].deletedService`)
                                        : context.t(`["receipt/detail/id"].deletedService`)
                                    }
                                    labelKey="name"
                                    valueKey="id"
                                    handler={(service_id) => {
                                      setCheckoutData({
                                        ...checkout_data,
                                        packages: {
                                          ...checkout_data.packages,
                                          [key]: {
                                            ...checkout_data.packages[key],
                                            service_id:
                                              parseInt(service_id),
                                          },
                                        },
                                      });
                                      setPackageChanges(true);
                                    }}
                                  />
                                </Column>

                                {/* Personel Select - Sadece personel seçiliyse veya hiçbiri seçili değilse göster */}
                                {(checkout_data.packages[key].staff_id || !checkout_data.packages[key].room_id) && (
                                  <Column className="xs-12 sm-12 md-12 lg-2">
                                    <StaffSelect
                                      className="mb-1"
                                      disabled={
                                        context.state.user.permission === 0
                                      }
                                      label={context.t(
                                        `['receipt/detail/id'].serviceTransactions.staffInputLabel`
                                      )}
                                      items={staffs}
                                      selected={
                                        checkout_data.packages[key].staff_id
                                          ? checkout_data.packages[key].staff_id
                                          : ""
                                      }
                                      labelKey="full_name"
                                      valueKey="id"
                                      handler={(staff_id) => {
                                        setCheckoutData({
                                          ...checkout_data,
                                          packages: {
                                            ...checkout_data.packages,
                                            [key]: {
                                              ...checkout_data.packages[key],
                                              staff_id: parseInt(staff_id),
                                              room_id: null,
                                            },
                                          },
                                        });
                                        setLateCheckout({
                                          ...checkout_data,
                                          packages: {
                                            ...checkout_data.packages,
                                            [key]: {
                                              ...checkout_data.packages[key],
                                              staff_id: parseInt(staff_id),
                                              room_id: null,
                                            },
                                          },
                                        })
                                        setPackageChanges(true);
                                      }}
                                    />
                                  </Column>
                                )}

                                {/* Oda Select - Sadece oda seçiliyse veya hiçbiri seçili değilse göster */}
                                {(checkout_data.packages[key].room_id || !checkout_data.packages[key].staff_id) && (
                                  <Column className="xs-12 sm-12 md-12 lg-2">
                                    <Select
                                      className="mb-1"
                                      disabled={context.state.user.permission === 0}
                                      label="Oda"
                                      items={(rooms || [])
                                        .filter(room => room && (room.ID || room.id))
                                        .map(room => ({
                                          id: room.ID || room.id,
                                          name: room.Name || room.name,
                                          backgroundColor: '',
                                          color: ''
                                        }))}
                                      selected={
                                        checkout_data.packages[key].room_id
                                          ? checkout_data.packages[key].room_id
                                          : ""
                                      }
                                      labelKey="name"
                                      valueKey="id"
                                      title={
                                        rooms && checkout_data.packages[key].room_id
                                          ? rooms.find(r => (r.ID || r.id) === checkout_data.packages[key].room_id)?.Name ||
                                          rooms.find(r => (r.ID || r.id) === checkout_data.packages[key].room_id)?.name || ""
                                          : ""
                                      }
                                      handler={(room_id) => {
                                        setCheckoutData({
                                          ...checkout_data,
                                          packages: {
                                            ...checkout_data.packages,
                                            [key]: {
                                              ...checkout_data.packages[key],
                                              room_id: parseInt(room_id),
                                              staff_id: null,
                                            },
                                          },
                                        });
                                        setLateCheckout({
                                          ...checkout_data,
                                          packages: {
                                            ...checkout_data.packages,
                                            [key]: {
                                              ...checkout_data.packages[key],
                                              room_id: parseInt(room_id),
                                              staff_id: null,
                                            },
                                          },
                                        })
                                        setPackageChanges(true);
                                      }}
                                    />
                                  </Column>
                                )}

                                <Column className="xs-12 sm-12 md-12 lg-2">
                                  <Select
                                    className="mb-1"
                                    disabled={
                                      context.state.user.permission === 0
                                    }
                                    label={context.t(`sms.bottom_table_titles.status`)}
                                    items={customer_s}
                                    selected={
                                      checkout_data.packages[key]
                                        .customer_state !== null
                                        ? `${checkout_data.packages[key].customer_state}`
                                        : ""
                                    }
                                    labelKey="label"
                                    valueKey="value"
                                    handler={(customer_state) => {
                                      setCheckoutData({
                                        ...checkout_data,
                                        packages: {
                                          ...checkout_data.packages,
                                          [key]: {
                                            ...checkout_data.packages[key],
                                            customer_state:
                                              parseInt(customer_state),
                                          },
                                        },
                                      });
                                    }}
                                  />
                                </Column>
                                <Column className="xs-12 sm-12 md-12 lg-2">
                                  <Input
                                    className="mb-1"
                                    label={
                                      "Seans Fiyatı" +
                                      (context.state.currency
                                        ? " (" + context.state.currency + ")"
                                        : "(₺)")
                                    }
                                    value={
                                      checkout_data.packages[key].amount
                                        ? Number.isInteger(Number(checkout_data.packages[key].amount))
                                          ? Math.round(checkout_data.packages[key].amount).toLocaleString('tr-TR')
                                          : Number(checkout_data.packages[key].amount).toLocaleString('tr-TR', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })
                                        : "0"
                                    }
                                    onChange={(e) => {
                                      // Kullanıcının girdiği değeri al
                                      const inputValue = e.target.value;

                                      // Sadece sayılar, virgül ve nokta karakterlerine izin ver
                                      if (!/^[0-9.,]*$/.test(inputValue) && inputValue !== "") {
                                        return;
                                      }

                                      // Virgül ve noktaları uygun şekilde dönüştür
                                      const numericValue = inputValue.replace(/\./g, '').replace(',', '.');
                                      const newAmount = parseFloat(numericValue) || 0;

                                      // Grup toplam tutarını hesapla
                                      const receiptPackageId = checkout_data.packages[key].receipt_package_id;

                                      // Bu gruptaki tüm paketleri bul
                                      const packageItemsInGroup = Object.keys(checkout_data.packages)
                                        .filter(k =>
                                          checkout_data.packages[k] !== undefined &&
                                          checkout_data.packages[k].receipt_package_id === receiptPackageId &&
                                          checkout_data.packages[k].process_type === 1
                                        );

                                      // Paketleri hazırla
                                      const updatedPackages = { ...checkout_data.packages };

                                      // Güncellenecek seansın fiyatını ayarla - sadece tam sayı kaydet
                                      updatedPackages[key] = {
                                        ...checkout_data.packages[key],
                                        amount: Math.round(newAmount),
                                      };

                                      // Diğer seansların toplam tutarını hesapla
                                      let totalWithoutThisPackage = 0;
                                      packageItemsInGroup.forEach(k => {
                                        if (k !== key) {
                                          totalWithoutThisPackage += Math.round(parseFloat(checkout_data.packages[k].amount || 0));
                                        }
                                      });

                                      // Güncellenecek toplam tutar (eğer kullanıcı mevcut seansın fiyatını değiştirdiyse)
                                      const totalAmount = Math.round(newAmount) + totalWithoutThisPackage;

                                      // Grup nesnelerini güncelle
                                      const groupIndex = checkout_data.groups.findIndex(group => group.id === receiptPackageId);
                                      if (groupIndex !== -1) {
                                        // GroupsAmount objesini güncelle
                                        const updatedGroupsAmount = { ...checkout_data.groupsAmount };
                                        if (updatedGroupsAmount[groupIndex]) {
                                          updatedGroupsAmount[groupIndex] = {
                                            ...updatedGroupsAmount[groupIndex],
                                            amount: totalAmount
                                          };
                                        }

                                        // Groups dizisini güncelle
                                        const updatedGroups = [...checkout_data.groups];
                                        updatedGroups[groupIndex] = {
                                          ...updatedGroups[groupIndex],
                                          amount: totalAmount
                                        };

                                        // Tüm güncellemeleri tek seferde yap
                                        setCheckoutData({
                                          ...checkout_data,
                                          groupsAmount: updatedGroupsAmount,
                                          groups: updatedGroups,
                                          packages: updatedPackages
                                        });

                                        setPackageChanges(true);
                                        setHasUnsavedChanges(true);
                                      } else {
                                        // Grup bulunamazsa sadece paket fiyatını güncelle
                                        setCheckoutData({
                                          ...checkout_data,
                                          packages: updatedPackages
                                        });
                                        setPackageChanges(true);
                                        setHasUnsavedChanges(true);
                                      }
                                    }}
                                  />
                                </Column>
                                {!checkout_data.packages[key].button_passive && (
                                  <Column className="xs-12 sm-12 md-12 lg-1">
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: '100%', gap: '5px', marginTop: '-5px' }}>
                                      <img src={Credit} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                                        const sessionData = checkout_data?.packages?.[key];
                                        preparePaymentForm(sessionData, 1);
                                        // Kaydedilmemiş değişiklikler varsa uyarı diyaloğu göster
                                        if (hasUnsavedChanges) {
                                          setSaveCreditDialogOpen(true);
                                        } else {
                                          setInstallmentDialog(true);
                                        }
                                      }} />
                                      <img src={Cash} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                                        const sessionData = checkout_data?.packages?.[key];
                                        preparePaymentForm(sessionData, 1);
                                        // Kaydedilmemiş değişiklikler varsa uyarı diyaloğu göster
                                        if (hasUnsavedChanges) {
                                          setSaveCashDialogOpen(true);
                                        } else {
                                          setAddPaymentDialog(true);
                                        }
                                      }} />
                                    </div>
                                  </Column>
                                )}
                                {checkout_data.packages[key].process_date &&
                                  is_package && (
                                    <Column className="xs-12 sm-12 md-12 lg-1 mt-1">
                                      <Button
                                        icon={checkout_data?.packages[key]?.appointment_id === 0 ? "event" : 'event_available'}
                                        iconSize={21}
                                        buttonTitle={checkout_data?.packages[key]?.appointment_id === 0 ? "Randevu Oluştur" : 'Randevuya Git'}
                                        textColor={checkout_data?.packages[key]?.appointment_id === 0 ? "blue" : "green"}
                                        size="lg"
                                        fullWidth
                                        onClick={() => {
                                          if (checkout_data?.packages[key]?.appointment_id === 0) {
                                            if (packageChanges) {
                                              toast.warning(
                                                context.t(`["receipt/detail/id"].saveBeforeGetAppointmentWarnToast`)
                                              );
                                            } else {
                                              setCheckoutDataDialog(true);
                                              setSelectedTime(moment().hour() + ":" + moment().minutes());
                                              setSelectedDate(
                                                new Date(
                                                  checkout_data.packages[
                                                    key
                                                  ].process_date
                                                ).toISOString()
                                              );
                                              setSelectedReceiptId(checkout_data.packages[key].id)
                                              setSelectedService(checkout_data.packages[key].service_id);
                                              setSelectedStaff(checkout_data.packages[key].staff_id);
                                            }
                                          } else {
                                            getAppointment(checkout_data?.packages[key]?.appointment_id);
                                            setAppointmentDetailModal(true);
                                            // history.push('/appointments', {
                                            //   appointment_id: checkout_data?.packages[key]?.appointment_id,
                                            //   data: {
                                            //     appointment_start_date: moment(checkout_data.packages[key].process_date).format("YYYY-MM-DD")
                                            //   }
                                            // })
                                          }
                                        }}
                                      />
                                    </Column>
                                  )}
                              </Grid>
                            )
                        )
                    ) : (
                      <NoDataContainer style={{ height: "70%" }}>
                        <img
                          src={require("../../../../assets/images/manypixels/click_action.svg")}
                          alt="Malesef bulunamadı!"
                        />
                        <p>
                          {context.t(
                            `['receipt/detail/id'].serviceTransactions.noDataPackageText`
                          )}
                        </p>
                      </NoDataContainer>
                    )
                  }
                </Column>
              )}
            </ReportsContainer>
          ))}

        {checkout_data.groups.length === 0 ? (
          <NoDataContainer style={{ height: "80%" }}>
            <img
              src={require("../../../../assets/images/no-data-img.png")}
              alt="Malesef bulunamadı!"
            />
            <p>
              {context.t(
                `['receipt/detail/id'].serviceTransactions.noDataPackageText`
              )}
            </p>
          </NoDataContainer>
        ) : (
          <></>
        )}
      </ListSection>

      {Object.values(checkout_data.packages).length > 0 && (
        <SubTotalText className="mt-2">
          <CustomerBoxDiv>
            <Button
              style={{
                border: "1px solid rgba(255, 127, 80, 0.53)",
              }}
              disabled={
                Object.keys(checkout_data.packages).filter(
                  (key) => checkout_data.packages[key] !== undefined
                ).length === 0
              }
              className="mr-2"
              icon="emoji_symbols"
              title={context.t(
                `['receipt/detail/id'].applyDiscountButtonTitle`
              )}
              backgroundColor="orange-opacity"
              textColor="orange"
              onClick={() => {
                if (
                  Object.keys(checkout_data.paids).filter(
                    (key) => checkout_data.paids[key] !== undefined
                  ).length === 0 &&
                  Object.keys(checkout_data.installment).filter(
                    (key) => checkout_data.installment[key] !== undefined
                  ).length === 0
                ) {
                  setDiscountTarget("groupsAmount");
                  setDiscountValue(null);
                  setDiscountType("TL");
                  setDiscountModal(true);
                } else {
                  toast.warning(
                    context.t(
                      `['receipt/detail/id'].discountBeforePaymentToast`
                    )
                  );
                }
              }}
            />
            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={RemainingDebtRed} alt="remaining_debt_red" />
              <CustomerPointBox>
                {getTotalAmounts().groupsAmount !==
                  getTotalAmounts()._fgroups ? (
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <p
                      style={{ textDecoration: "line-through" }}
                      className="fc-grey mr-1"
                    >
                      {Math.round(getTotalAmounts()._fgroups)}
                      {context.state.currency
                        ? context.state.currency
                        : "₺"}
                    </p>
                    <p>
                      {Math.round(getTotalAmounts().packages) || 0}
                      {context.state.currency
                        ? context.state.currency
                        : "₺"}
                    </p>
                  </span>
                ) : (
                  <span>
                    <p>
                      {Math.round(getTotalAmounts().packages) || 0}
                      {context.state.currency
                        ? context.state.currency
                        : "₺"}
                    </p>
                  </span>
                )}
                <h3>
                  {context.t(
                    `['receipt/detail/id'].serviceTransactions.packageTotalAmount`
                  )}
                </h3>
              </CustomerPointBox>
            </div>
          </CustomerBoxDiv>
        </SubTotalText>
      )}
      <AlertDialog
        closeHandler={() => {
          setServicesUpdateModal(false);
        }}
        open={services_update_modal}
        title={context.t(`["receipt/detail/id"].packageSessionUpdateTitle`)}
        buttons={[
          {
            title: context.t(`receipts.detailButton.confirmButton`),
            backgroundColor: "primary-opacity",
            textColor: "primary",
            icon: "check",
            onClick: async () => {
              await setTransictionsToState();
            },
          },
          {
            title: context.t(`["packages/add"].discardButtonTitle`),
            outlined: true,
            textColor: "#fff",
            icon: "clear",
            onClick: () => {
              setSelectedPackageTransitionUpdateState(null);
              setSelectedPackageTransitionId(null)
            },
          },
        ]}
      >
        <p>
          {context.t(`["receipt/detail/id"].packageSessionUpdateText1`).replace("%s",
            selected_package_transition_update_state === 0
              ? context.t(`appointments.detail.appointmentStatus.arrived`)
              : selected_package_transition_update_state === 2
                ? context.t(`appointments.detail.appointmentStatus.waiting`)
                : context.t(`appointments.detail.appointmentStatus.notArrived`))}
          <br />
          <br />
          {context.t(`["receipt/detail/id"].packageSessionUpdateText2`)}
        </p>
      </AlertDialog>

      <AlertDialog
        closeHandler={() => {
          setServicesUpdateDateModal(false);
        }}
        open={services_update_date_modal}
        title={context.t(`["receipt/detail/id"].packageDateUpdateTitle`)}
        buttons={[
          {
            title: context.t(`receipts.detailButton.confirmButton`),
            backgroundColor: "primary-opacity",
            textColor: "primary",
            icon: "check",
            onClick: async () => {
              await setTransictionsToDate();
            },
          },
          {
            title: context.t(`["packages/add"].discardButtonTitle`),
            outlined: true,
            textColor: "#fff",
            icon: "clear",
            onClick: () => {
              setPackageUpdateDate(null);
              setSelectedPackageTransitionId(null);
              setSelectedPackageUpdateDate(null);
            },
          },
        ]}
      >
        {context.t(`["receipt/detail/id"].packageDateUpdateText`)}
        <br />
        {context.t(`["receipt/detail/id"].packageSessionUpdateText2`)}
      </AlertDialog>

      <AlertDialog
        closeHandler={() => {
          setPackageDeleteModal(false);
        }}
        open={package_delete_modal}
        title={context.t(`["receipt/detail/id"].packageDeleteTitle`)}
        buttons={[
          {
            title: context.t(`receipts.detailButton.confirmButton`),
            backgroundColor: "primary-opacity",
            textColor: "primary",
            icon: "check",
            onClick: async () => {
              await setCheckoutData({
                ...checkout_data,
                packages: Object.assign(
                  {},
                  Object.values(checkout_data.packages).filter(
                    (item) =>
                      item.receipt_package_id !==
                      delete_package_id
                  )
                ),
                groups: checkout_data.groups.filter(
                  (item) => item.id !== delete_package_id
                ),
              });
            },
          },
          {
            title: context.t(`["packages/add"].discardButtonTitle`),
            outlined: true,
            textColor: "#fff",
            icon: "clear",
          },
        ]}
      >
        {context.t(`["receipt/detail/id"].packageDeleteText1`)}
        <br />
        {context.t(`["receipt/detail/id"].packageSessionUpdateText2`)}
      </AlertDialog>

      <AlertDialog
        closeHandler={() => {
          setLastServicesFromPackageToDeleteModal(false);
        }}
        open={last_services_from_package_to_delete_modal}
        title={context.t(`["receipt/detail/id"].packageDeleteTitle`)}
        buttons={[
          {
            title: context.t(`receipts.detailButton.confirmButton`),
            backgroundColor: "primary-opacity",
            textColor: "primary",
            icon: "check",
            onClick: async () => {
              // delete checkout_data.packages[
              //   key_for_delete_services
              // ];
              await setCheckoutData({
                ...checkout_data,
                groups: checkout_data.groups.filter(
                  (item) => item.id !== delete_package_id
                ),
                packages: Object.assign(
                  {},
                  Object.values(checkout_data.packages).filter(
                    (item) =>
                      item.receipt_package_id !==
                      delete_package_id
                  )
                ),
              });
              await setCheckoutData({
                ...checkout_data,
              });
              await setIsChange(true);

              setTimeout(() => {
                setDeletedPackages([]);
                setDeletedPackagesServicesTransactionPackageId(null);
              }, 250);
            },
          },
          {
            title: context.t(`["packages/add"].discardButtonTitle`),
            outlined: true,
            textColor: "#fff",
            icon: "clear",
            onClick: () => { },
          },
        ]}
      >
        {context.t(`["receipt/detail/id"].packageDeleteText2`)}
        <br />
        {context.t(`["receipt/detail/id"].packageSessionUpdateText2`)}
      </AlertDialog>
    </SectionBox>
  );
};


const InfoCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 5px;
  padding: 2px 5px;
  height: 40px;
  width: 40px;
  cursor: pointer;
`;

const InfoCardText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  span {
    font-size: 13px;
    font-weight: 500;
    padding: 5px;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

const ReportsHeader = styled.div`
  width: 100%;
  cursor: pointer;
  font-size: 1.2em;
  font-weight: 500;
  display: flex;
  color: #4d4d4d;
  display: flex;
  align-items: center;
  justify-content: start;
`;

const ReportsHeaderIcon = styled.span`
  padding-right: 10px;
`;
const ReportsContainer = styled.div`
  border-bottom: 1px solid #b2b2b2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5em;
  flex-direction: column;
  overflow: hidden;
`;
const SectionBox = styled.div`
  width: 100%;
  overflow-x: scroll;
  box-sizing: border-box;
  padding-top: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  color: var(--dark-primary);

  h3{font - size: 18px; font-weight: 600; flex: 1; margin: 0; padding: 0}
`;

const ListSection = styled.div`
  overflow-x: scroll;
  margin-bottom: auto;
  padding-left: 5px;
  padding-right: 5px;
`;

const PaymentSection = styled.div`
  width: 95%;
  height: 57px;
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
`;

const SubTotalText = styled.div`
  span {
    font-size: 13px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

const CustomerBox = styled.div``;

const CustomerBoxDiv = styled.div`
  width: 100%;
  height: 57px;
  padding: 8px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 5px;

  img {
    width: 30px;
    height: 30px;
    margin-right: 8px;
    margin-top: 7px;
    margin-left: 10px;
  }
`;

const CustomerPointBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  margin-top: 5px;

  h3 {
    font-size: 13px;
    font-weight: 500;
    margin: 0;
    color: #3c3c3c;
  }

  span {
    font-size: 15px;
    font-weight: 500;
    line-height: 15px;

    b {
      font-size: 13px;
      font-weight: 400;
      color: #aaa;
    }
  }
`;

const SelectedBoxPhoto = styled.img`
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 5px;
  background-color: #fafafa;
  margin-right: 16px;
`;

const CustomerBoxInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media only screen and (max-width: 576px) {
    flex - direction: column;
    div, img {margin: 0 !important}
  }

  div{
    b, span {margin: 0; padding: 0; display: block;}
    b{
      font - size: 15px; font-weight: 500
    }

    &.call_button{
      margin - left: 24px;
      flex: 1
      display:flex;
      justify-content: flex-end;
    }
  }
`;

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 16px;

  img {
    width: 100%;
    max-height: 32vh;
    object-fit: contain;
  }
  p {
    color: #407bff;
    font-size: 18px;
    font-weight: 500;
    padding-top: 16px;
    text-align: center;
  }
`;

const AdvancedType = styled.div`
  display: flex;
  width: 190px;
  height: 88px;
  border-radius: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  cursor: pointer;
`;

const ColorMean = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  justify-content: center;

  &:nth-last-child(1) {
    margin: 0;
  }

  div.color {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    margin-right: 8px;

    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgb(255, 255, 255);
      background: linear-gradient(
        -180deg,
        rgba(255, 255, 255, 0.25) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  span {
    flex: 1;
    font-size: 14px;
    line-height: 1.2;
    font-weight: 500;
    color: #000000;
  }
`;

const ImageUploadBox = styled.label`
  display: flex;
  width: -webkit-fill-available;
  padding: 32px;
  text-align: center;
  align-items: center;
  justify-content: center;
  background: #fefefe;
  border: 2px dotted #eaeaea;
  border-radius: 5px;
  cursor: pointer;
  color: #808080;
  font-size: 15px;
  font-weight: 500;
  transition: all ease 0.35s;

  &:hover {
    border: 2px dotted #dadada;
    color: #000;
  }

  i.material-icons {
    font-size: 21px;
    margin-right: 8px;
  }
`;

const ReceiptProfile = styled.div`
  display: flex;
  flex-direction: column;
  height: 57px;
  width: 100%;
  border-radius: 5px;

  div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 100%;
    padding: 2px;
  }
`;

const SaveChangesButton = styled.div`
  position: fixed;
  top: 75px;
  right: 4vw;
  z-index: 999;
  width: 20vw;
`;

const ServicesSectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  color: var(--dark-primary);
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
  margin-bottom:16px;

  h3{font - size: 18px; font-weight: 600; flex: 1; margin: 0; padding: 0}
`;

const StaffList = styled.div`
  height: 26vh;
  box-shadow: inset 0 0 5px #3189ec;
  border-radius: 10px;
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
  margin: 0;
`;

const ServicesList = styled.div`
  height: 22.5vh;
  box-shadow: inset 0 0 5px #3189ec;
  border-radius: 10px;
  overflow: scroll;
`;

const Services = styled.div`
  height: 63vh;
  border-radius: 10px;
  overflow: auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PackageDetailContainer = styled.div`
  flex-direction: column;
  overflow: hidden;
`;
